import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { sdkTypes } from '@vansite/ts-sharetribe-flex-sdk';
import Decimal from 'decimal.js';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import ControlledCheckBox from '../../components/BasicUI/ControlledInputs/ControlledCheckBox';
import { formatMoney } from '../../util/currency';
import {
  EXTRA_LINE_ITEM_ELECTRICITY,
  EXTRA_LINE_ITEM_SHOWER,
  EXTRA_LINE_ITEM_WATER,
  EXTRA_LINE_ITEM_WC,
} from '../../util/types';

const { Money } = sdkTypes;

const getExtraLineItemName = (key, intl) => {
  switch (key) {
    case EXTRA_LINE_ITEM_ELECTRICITY:
      return intl.formatMessage({ id: 'Filter.amenities.electricity' });
    case EXTRA_LINE_ITEM_WATER:
      return intl.formatMessage({ id: 'Filter.amenities.water' });
    case EXTRA_LINE_ITEM_SHOWER:
      return intl.formatMessage({ id: 'Filter.amenities.shower' });
    case EXTRA_LINE_ITEM_WC:
      return intl.formatMessage({ id: 'Filter.amenities.wc' });
    default:
      return '';
  }
};

const getTypeLabel = (type, intl) => {
  const perNight = type?.perNight
    ? intl.formatMessage({ id: 'BookingDatesForm.customLineItem.perNight' })
    : null;
  const perGuest = type?.perGuest
    ? intl.formatMessage({ id: 'BookingDatesForm.customLineItem.perGuest' })
    : null;
  const and = intl.formatMessage({ id: 'BookingDatesForm.customLineItem.and' });

  if (perNight && !perGuest) {
    return `/${perNight}`;
  }
  if (perGuest && !perNight) {
    return `/${perGuest}`;
  }
  if (perGuest && perNight) {
    return `/${perGuest} ${and} ${perNight}`;
  }
  return '';
};

const ExtraLineItemsStepComponent = ({
  control,
  extraLineItems,
  disabled = false,
}) => {
  const intl = useIntl();

  const extraLineItemKeys = Object.keys(extraLineItems);

  if (extraLineItemKeys.length === 0) {
    return null;
  }

  const infoText = intl.formatMessage({ id: 'BookingDatesForm.extraLineItemsStepInfo' });

  return (
    <Stack direction="column" spacing={1}>
      <Typography color="text.secondary" variant="body2">
        {infoText}
      </Typography>
      <Stack direction="column" spacing={0}>
      {extraLineItemKeys.map((key) => {
        const item = extraLineItems[key];
        const price = new Money(
          new Decimal(item.price.amount).round().toNumber(),
          item.price.currency,
        );
        const formattedPrice = formatMoney(intl, price);
        const name = getExtraLineItemName(key, intl);
        const typeLabel = getTypeLabel(item.type, intl);

        const label = (
          <span>
            {`${name} - ${formattedPrice}`}
            <Typography color="text.secondary" component="span" variant="body2"> 
              {' '}{typeLabel}
            </Typography>
          </span>
        );

        return (
          <ControlledCheckBox
            control={control}
            disabled={disabled}
            key={key}
            label={label}
            name={`extraLineItems.${key}.add`}
          />
        );
      })}
      </Stack>
    </Stack>
  );
};

const ExtraLineItemsStep = memo(ExtraLineItemsStepComponent);

export default ExtraLineItemsStep;
